export function buildSignInRedirect(options?: { expired?: boolean }): string {
  const params = new URLSearchParams()

  if (options?.expired) {
    params.set("expired", "true")
  }

  if (typeof window !== "undefined") {
    const target = `${window.location.pathname}${window.location.search}${window.location.hash}`

    if (target && target !== "/" && target !== "/sign-in") {
      params.set("redirect", target)
    }
  }

  const query = params.toString()
  return query ? `/sign-in?${query}` : "/sign-in"
}

// Resolve the candidate the same way the browser will, then keep it only if it
// landed on our own origin. Character-level checks cannot work here: the WHATWG URL
// parser rewrites the string before it resolves it — "\" becomes "/", and ASCII tab,
// LF and CR are stripped entirely — so "/<TAB>/evil.com" silently becomes
// "//evil.com". Every such rewrite is a bypass of any prefix test, and the list is
// not something to enumerate by hand. Asking the parser is the only check that stays
// correct as that list grows.
//
// Reachable via ?redirect= on /sign-in and ?next= on /act-as, where searchParams.get()
// percent-decodes, so %09 arrives here as a real tab. The /act-as value reaches
// window.location.assign(), a bare browser navigation with no framework in between.
//
// Returns the re-serialised path so callers navigate to what was actually validated,
// never the raw input.
export function getSafeRedirectTarget(redirectTarget: string | null) {
  if (!redirectTarget?.startsWith("/")) return null
  if (typeof window === "undefined") return null

  const origin = window.location.origin
  try {
    const resolved = new URL(redirectTarget, origin)
    return resolved.origin === origin
      ? `${resolved.pathname}${resolved.search}${resolved.hash}`
      : null
  } catch {
    return null
  }
}
